(function(){
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var body = document.body;
  var $ = function(s, c){ return (c || document).querySelector(s); };
  var $$ = function(s, c){ return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desk = window.matchMedia('(min-width: 990px)');
  var canHover = window.matchMedia('(hover: hover)').matches;
  window.NB = window.NB || {};

  /* ---------- overlay + drawers ---------- */
  var overlay = $('#nbOverlay');
  var openEl = null, lastFocus = null;
  function openDrawer(el){
    if(!el) return;
    if(openEl && openEl !== el) closeDrawer(true);
    lastFocus = document.activeElement;
    openEl = el;
    body.classList.toggle('nb-head-top', !!el.closest('.nb-header-wrap'));
    el.classList.add('is-open');
    el.setAttribute('aria-hidden','false');
    if(overlay) overlay.classList.add('is-open');
    body.classList.add('nb-lock');
    var f = el.querySelector('input:not([type=hidden]),button,a');
    setTimeout(function(){ if(f) try{ f.focus({preventScroll:true}); }catch(e){} }, 80);
  }
  function closeDrawer(silent){
    if(!openEl) return;
    openEl.classList.remove('is-open');
    openEl.setAttribute('aria-hidden','true');
    openEl = null;
    if(overlay) overlay.classList.remove('is-open');
    body.classList.remove('nb-lock');
    setTimeout(function(){ if(!openEl) body.classList.remove('nb-head-top'); }, 560);
    if(!silent && lastFocus) try{ lastFocus.focus({preventScroll:true}); }catch(e){}
  }
  NB.openDrawer = openDrawer; NB.closeDrawer = closeDrawer;
  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-open]');
    if(t){ e.preventDefault(); openDrawer(document.getElementById(t.getAttribute('data-open'))); return; }
    if(e.target.closest('[data-close]') || e.target === overlay){ e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') closeDrawer(); });

  /* ---------- reveal ---------- */
  function initReveal(scope){
    var els = $$('[data-reveal]:not(.is-in)', scope);
    if(!('IntersectionObserver' in window) || reduce){ els.forEach(function(el){ el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, {rootMargin:'0px 0px -6% 0px', threshold:.06});
    els.forEach(function(el){ io.observe(el); });
  }
  initReveal(document);

  /* ---------- rails ---------- */
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-rail-btn]');
    if(!b) return;
    var rail = document.getElementById(b.getAttribute('data-rail'));
    if(!rail) return;
    var dir = b.getAttribute('data-rail-btn') === 'next' ? 1 : -1;
    rail.scrollBy({left: dir * rail.clientWidth * .8, behavior: reduce ? 'auto' : 'smooth'});
  });

  /* ---------- footer accordions: open on desktop, closed on mobile ---------- */
  function syncFooter(){ $$('.nb-fcol').forEach(function(d){ if(desk.matches) d.setAttribute('open',''); else d.removeAttribute('open'); }); }
  syncFooter();
  if(desk.addEventListener) desk.addEventListener('change', syncFooter);

  /* ---------- hero parallax ---------- */
  var fam = $('[data-family]');
  if(fam && !reduce && canHover){
    var panel = fam.closest('.nb-hero__panel') || fam;
    panel.addEventListener('mousemove', function(e){
      var r = panel.getBoundingClientRect();
      var px = ((e.clientX - r.left) / r.width - .5) * 2;
      var py = ((e.clientY - r.top) / r.height - .5) * 2;
      $$('.nb-family__item', fam).forEach(function(i){ i.style.setProperty('--px', px.toFixed(3)); i.style.setProperty('--py', py.toFixed(3)); });
    });
    panel.addEventListener('mouseleave', function(){ $$('.nb-family__item', fam).forEach(function(i){ i.style.setProperty('--px', 0); i.style.setProperty('--py', 0); }); });
  }

  /* ---------- money ---------- */
  function money(cents){
    var fmt = NB.moneyFormat || '£{{amount}}';
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0]).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0] + ',' + parts[1]).replace(/\{\{\s*amount\s*\}\}/, withComma);
  }
  NB.money = money;

  /* ---------- cart ---------- */
  function updateCount(count){ $$('[data-cart-count]').forEach(function(el){ el.textContent = count; }); }
  function refreshCart(open){
    return fetch(root + '?sections=nb-cart-drawer', {credentials:'same-origin'})
      .then(function(r){ return r.json(); })
      .then(function(data){
        var html = data['nb-cart-drawer'];
        if(!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-inner]');
        var cur = document.querySelector('[data-cart-inner]');
        if(fresh && cur){ cur.innerHTML = fresh.innerHTML; }
        var c = doc.querySelector('[data-cart-total-count]');
        if(c) updateCount(c.getAttribute('data-cart-total-count'));
        if(open) openDrawer(document.getElementById('CartDrawer'));
      });
  }
  NB.refreshCart = refreshCart;
  function addItems(items){
    return fetch(root + 'cart/add.js', {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({items: items})})
      .then(function(r){ return r.json().then(function(j){ if(!r.ok) throw j; return j; }); });
  }
  NB.addItems = addItems;
  function showError(form, err){
    var box = form.querySelector('[data-form-error]');
    var msg = (err && (err.description || err.message)) || 'Something went wrong. Please try again.';
    if(box){ box.textContent = msg; box.hidden = false; } else { alert(msg); }
  }
  document.addEventListener('submit', function(e){
    var form = e.target.closest('[data-nb-add]');
    if(!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    var errBox = form.querySelector('[data-form-error]'); if(errBox) errBox.hidden = true;
    if(btn) btn.classList.add('is-loading');
    var fd = new FormData(form);
    addItems([{id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || '1', 10)}])
      .then(function(){ return refreshCart(true); })
      .catch(function(err){ showError(form, err); })
      .then(function(){ if(btn) btn.classList.remove('is-loading'); });
  });
  document.addEventListener('click', function(e){
    var q = e.target.closest('[data-quick-add]');
    if(q){
      e.preventDefault();
      q.classList.add('is-loading'); q.disabled = true;
      addItems([{id: parseInt(q.getAttribute('data-quick-add'), 10), quantity: 1}])
        .then(function(){ return refreshCart(true); })
        .catch(function(err){ alert((err && err.description) || 'Could not add to cart.'); })
        .then(function(){ q.classList.remove('is-loading'); q.disabled = false; });
      return;
    }
    var ch = e.target.closest('[data-line-change]');
    if(ch){
      e.preventDefault();
      var wrap = ch.closest('.nb-line'); if(wrap) wrap.style.opacity = .5;
      fetch(root + 'cart/change.js', {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'}, body: JSON.stringify({line: parseInt(ch.getAttribute('data-line'), 10), quantity: parseInt(ch.getAttribute('data-line-change'), 10)})})
        .then(function(r){ return r.json(); })
        .then(function(){ if(body.classList.contains('template-cart')){ window.location.reload(); return; } return refreshCart(false); });
      return;
    }
    var bundleBtn = e.target.closest('[data-bundle-add]');
    if(bundleBtn){
      e.preventDefault();
      var box = bundleBtn.closest('[data-bundle]');
      var items = $$('input[type=checkbox]:checked', box).map(function(i){ return {id: parseInt(i.value, 10), quantity: 1}; });
      if(!items.length) return;
      bundleBtn.classList.add('is-loading');
      addItems(items).then(function(){ return refreshCart(true); })
        .catch(function(err){ alert((err && err.description) || 'Could not add to cart.'); })
        .then(function(){ bundleBtn.classList.remove('is-loading'); });
    }
  });
  document.addEventListener('change', function(e){
    var box = e.target.closest('[data-bundle]');
    if(box && e.target.type === 'checkbox'){
      var total = 0, n = 0;
      $$('input[type=checkbox]:checked', box).forEach(function(i){ total += parseInt(i.getAttribute('data-price'), 10); n++; });
      var t = box.querySelector('[data-bundle-total]'); if(t) t.textContent = money(total);
      var c = box.querySelector('[data-bundle-count]'); if(c) c.textContent = n;
      var b = box.querySelector('[data-bundle-add]'); if(b) b.disabled = n === 0;
    }
  });
  document.addEventListener('click', function(e){
    var s = e.target.closest('[data-step]');
    if(!s) return;
    var input = s.parentNode.querySelector('input');
    if(!input) return;
    var v = parseInt(input.value || '1', 10) + parseInt(s.getAttribute('data-step'), 10);
    input.value = Math.max(parseInt(input.min || '1', 10), v);
    input.dispatchEvent(new Event('change', {bubbles:true}));
  });

  /* ---------- gallery ---------- */
  $$('[data-gallery]').forEach(function(g){
    var track = $('.nb-gallery__track', g);
    var slides = $$('.nb-gallery__slide', g);
    var dots = $$('.nb-gallery__dots span', g);
    var thumbs = $$('.nb-gallery__thumbs button', g);
    var counter = $('[data-gallery-count]', g);
    function setActive(n){
      dots.forEach(function(d, k){ d.classList.toggle('is-active', k === n); });
      thumbs.forEach(function(t, k){ t.classList.toggle('is-active', k === n); });
      if(counter) counter.textContent = (n + 1) + ' / ' + slides.length;
    }
    var raf;
    track.addEventListener('scroll', function(){ cancelAnimationFrame(raf); raf = requestAnimationFrame(function(){ setActive(Math.round(track.scrollLeft / track.clientWidth)); }); }, {passive:true});
    thumbs.forEach(function(t, k){ t.addEventListener('click', function(){ track.scrollTo({left: k * track.clientWidth, behavior: reduce ? 'auto' : 'smooth'}); }); });
    NB.galleryTo = function(mediaId){
      var idx = slides.findIndex(function(s){ return s.getAttribute('data-media-id') === String(mediaId); });
      if(idx > -1) track.scrollTo({left: idx * track.clientWidth, behavior: reduce ? 'auto' : 'smooth'});
    };
  });

  /* ---------- variants ---------- */
  $$('[data-product]').forEach(function(p){
    var json = $('[data-product-json]', p);
    if(!json) return;
    var data; try { data = JSON.parse(json.textContent); } catch(err){ return; }
    var form = $('[data-nb-add]', p);
    function selected(){ return $$('[data-option-index]', p).map(function(fs){ var c = $('input:checked', fs); return c ? c.value : null; }); }
    p.addEventListener('change', function(e){
      if(!e.target.closest('[data-option-index]')) return;
      var sel = selected();
      var v = data.variants.find(function(v){ return v.options.every(function(o, k){ return o === sel[k]; }); });
      var btns = $$('[data-atc]');
      if(!v){ btns.forEach(function(b){ b.disabled = true; b.querySelector('[data-atc-label]').textContent = 'Unavailable'; }); return; }
      if(form) form.querySelector('[name=id]').value = v.id;
      $$('[data-sticky-id]').forEach(function(x){ x.value = v.id; });
      $$('[data-price-now]').forEach(function(el){ el.textContent = money(v.price); });
      $$('[data-price-was]').forEach(function(el){ el.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; el.hidden = !(v.compare_at_price > v.price); });
      btns.forEach(function(b){ b.disabled = !v.available; b.querySelector('[data-atc-label]').textContent = v.available ? 'Add to cart' : 'Sold out'; });
      if(v.featured_media && NB.galleryTo) NB.galleryTo(v.featured_media.id);
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url.toString());
    });
  });

  /* ---------- sticky add to cart ---------- */
  var sticky = $('[data-sticky-atc]');
  var mainAtc = $('[data-main-atc]');
  if(sticky && mainAtc && 'IntersectionObserver' in window){
    new IntersectionObserver(function(entries){
      var past = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', past);
      body.classList.toggle('has-sticky-atc', past);
    }, {threshold:0}).observe(mainAtc);
  }

  /* ---------- predictive search ---------- */
  var sInput = $('[data-search-input]');
  var sOut = $('[data-search-results]');
  if(sInput && sOut){
    var timer, defaultHTML = sOut.innerHTML;
    sInput.addEventListener('input', function(){
      clearTimeout(timer);
      var q = sInput.value.trim();
      if(q.length < 2){ sOut.innerHTML = defaultHTML; sOut.className = 'nb-search__hint'; return; }
      timer = setTimeout(function(){
        fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8')
          .then(function(r){ return r.json(); })
          .then(function(d){
            var items = (d.resources && d.resources.results && d.resources.results.products) || [];
            if(!items.length){ sOut.className = 'nb-search__hint'; sOut.innerHTML = '<p>Nothing for "' + q.replace(/</g,'&lt;') + '" yet. Try cream or glow.</p>'; return; }
            sOut.className = 'nb-search__results';
            sOut.innerHTML = items.map(function(p){
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url + (p.featured_image.url.indexOf('?') > -1 ? '&' : '?') + 'width=400' : '';
              return '<a class="nb-search__item" href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy" width="400" height="400">' : '') + '<p>' + p.title.replace('Offer | ', '') + '</p><span>' + money(Math.round(parseFloat(p.price) * 100)) + '</span></a>';
            }).join('');
          }).catch(function(){});
      }, 220);
    });
  }

  document.addEventListener('shopify:section:load', function(e){ initReveal(e.target); syncFooter(); });
})();
